var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.model.items),function(user,index){return [_c('KitchenSinkUserFormGroup',{key:index,attrs:{"model":user,"validations":_vm.validations[index]}})]}),_c('FunctionalityButton',{attrs:{"content":{
            addLabel: 'Weiteren Anwender hinzufügen',
            removeLabel: 'Anwender entfernen',
            info: 'Hier können Sie einen weitern Anwender hinzufügen',
        },"value":_vm.functionalityButtonValue,"show-info-icon":""},on:{"click":function($event){return _vm.handleFunctionalityButtonClick($event)}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }